<app-common-loader *ngIf="carregandoTarefas"></app-common-loader>
<app-modal-mensagem
  *ngIf="tarefaCriadaSucesso"
  tipo="sucesso"
  titulo="Sucesso!"
  mensagem="Tarefa criada com sucesso!"
  (confirmar)="fecharSucesso()"
></app-modal-mensagem>

<app-modal-mensagem
  *ngIf="mensagemErro"
  tipo="erro"
  titulo="Não foi possível criar a tarefa"
  [mensagem]="mensagemErro"
  (confirmar)="fecharErro()"
></app-modal-mensagem>

<div class="modal-panel-tarefa">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 11l3 3L22 4" />
          <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
        </svg>
      </div>
      <div>
        <h2 class="modal-title">Criar tarefa - Obras</h2>
        <p class="modal-subtitle">Preencha os campos para criar uma nova tarefa</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="fecharModal()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <p class="hint" *ngIf="contatoInfo?.nome">
      Contato: <strong>{{ contatoInfo.nome }}</strong>
      <span *ngIf="contatoInfo.cargo"> — {{ contatoInfo.cargo }}</span>
    </p>

    <div class="form-group">
      <label class="form-label" for="obra">
        Obra
        <span class="required">*</span>
      </label>
      <app-filtro-select-busca
        [value]="selectedObra"
        [options]="opcoesObras"
        placeholder="Selecione uma obra"
        placeholderBusca="Buscar obra"
        [class.form-input--error]="campoObrigatorioErro && !selectedObra"
        (valueChange)="selectedObra = $event"
      ></app-filtro-select-busca>
      <span class="error-msg" *ngIf="campoObrigatorioErro && !selectedObra">Selecione uma obra</span>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="responsavel">
          Responsável
          <span class="required">*</span>
        </label>
        <app-filtro-select-busca
          [value]="responsibleID"
          [options]="opcoesResponsaveis"
          placeholder="Selecione"
          placeholderBusca="Buscar responsável"
          [class.form-input--error]="campoObrigatorioErro && !responsibleID"
          (valueChange)="responsibleID = $event"
        ></app-filtro-select-busca>
        <span class="error-msg" *ngIf="campoObrigatorioErro && !responsibleID">Selecione</span>
      </div>

      <div class="form-group">
        <label class="form-label" for="tarefa">
          Tipo de tarefa
          <span class="required">*</span>
        </label>
        <select
          id="tarefa"
          class="form-select"
          [(ngModel)]="actionID"
          [class.form-input--error]="campoObrigatorioErro && !actionID"
        >
          <option value="" disabled>Escolher tarefa</option>
          <option *ngFor="let r of tarefas" [value]="r.id">{{ r.description }}</option>
        </select>
        <span class="error-msg" *ngIf="campoObrigatorioErro && !actionID">Selecione</span>
      </div>
    </div>

    <div class="form-row form-row--data">
      <div class="form-group">
        <label class="form-label" for="data">
          Data
          <span class="required">*</span>
        </label>
        <input
          id="data"
          type="date"
          class="form-input"
          [min]="today"
          [(ngModel)]="data"
          [class.form-input--error]="campoObrigatorioErro && !data"
        />
        <span class="error-msg" *ngIf="campoObrigatorioErro && !data">Informe a data</span>
      </div>

      <div class="form-group">
        <label class="form-label" for="hora">
          Hora
          <span class="required">*</span>
        </label>
        <input
          id="hora"
          type="time"
          class="form-input"
          [(ngModel)]="hora"
          [class.form-input--error]="campoObrigatorioErro && !hora"
        />
        <span class="error-msg" *ngIf="campoObrigatorioErro && !hora">Informe a hora</span>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label" for="taskDescription">Descreva a tarefa</label>
      <textarea
        id="taskDescription"
        class="form-textarea"
        rows="4"
        maxlength="2000"
        [(ngModel)]="description"
        [class.form-input--error]="campoObrigatorioErro && !description"
        placeholder="Adicione informações sobre a tarefa..."
      ></textarea>
      <div class="textarea-footer">
        <span class="char-count">{{ description.length }}/2000</span>
      </div>
      <span class="error-msg" *ngIf="campoObrigatorioErro && !description">Campo obrigatório!</span>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" type="button" (click)="limparCampos(); fecharModal()">
      Cancelar
    </button>
    <button class="btn-primary" type="button" (click)="criarTarefa()" [disabled]="carregandoTarefas">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      Criar tarefa
    </button>
  </div>
</div>
